import { render, staticRenderFns } from "./SwitchBackup2.vue?vue&type=template&id=0f00b71b"
import script from "./SwitchBackup2.vue?vue&type=script&lang=js"
export * from "./SwitchBackup2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports